module.exports = __webpack_public_path__ + "static/media/smartmigraine-nav.6b70453e.png";